const getLinkedSQFTIds = (cartItem) => {
  const ids = Array.isArray(cartItem?.sqftIds) ? cartItem.sqftIds : [];
  return cartItem?.sqftId === undefined || cartItem?.sqftId === null
    ? ids
    : [...ids, cartItem.sqftId];
};

// Reconciles every calculator-linked cart item of a quote against its persisted shapes,
// for quotes that have drifted out of sync (cart material differs from the shape's stored feature).
export const syncQuoteSqftCalcDataWithCart = (quotes, quoteIndex, cartItems) => {
  const quote = quotes[quoteIndex];
  if (!quote || !Array.isArray(quote.sqFtCalcData?.countertops)) {
    return quotes;
  }

  const linkedCartItems = (cartItems || []).filter(cartItem =>
    Number(cartItem.currentQuote) === Number(quoteIndex) && getLinkedSQFTIds(cartItem).length > 0
  );
  if (linkedCartItems.length === 0) {
    return quotes;
  }

  // sqftId -> the material/partId the cart says should be there
  const desiredBySQFTId = new Map();
  linkedCartItems.forEach(cartItem => {
    const featureId = cartItem.cartFeature?.dbFeature?.id;
    if (!featureId) return;
    getLinkedSQFTIds(cartItem).forEach(sqftId => {
      desiredBySQFTId.set(String(sqftId), {featureId, partId: cartItem.partId});
    });
  });
  if (desiredBySQFTId.size === 0) {
    return quotes;
  }

  let hasChanges = false;
  const countertops = quote.sqFtCalcData.countertops.map(countertop => {
    const desired = desiredBySQFTId.get(String(countertop.id));
    if (!desired || String(countertop.featureId) === String(desired.featureId)) {
      return countertop;
    }

    hasChanges = true;
    const oldFeatureId = countertop.featureId;
    return {
      ...countertop,
      featureId: desired.featureId,
      features: Array.isArray(countertop.features)
        ? countertop.features.map(feature => {
          const isReplacedFeature = String(feature.featureId) === String(oldFeatureId)
            && (!feature.partId || feature.partId === desired.partId);
          return isReplacedFeature ? {...feature, featureId: desired.featureId} : feature;
        })
        : countertop.features,
    };
  });

  if (!hasChanges) {
    return quotes;
  }

  const updatedQuotes = [...quotes];
  updatedQuotes[quoteIndex] = {
    ...quote,
    sqFtCalcData: {
      ...quote.sqFtCalcData,
      countertops,
    },
  };
  return updatedQuotes;
};
